import cn from 'classnames'
import React from 'react'

import type { IFieldLayoutProps } from 'components/formKit/types'
import { Typography } from 'components/uiKit/Typography'

import * as s from './FieldBaseDescription.module.scss'

const FieldBaseDescription: React.FC<Omit<IFieldLayoutProps, 'children'>> = ({
  description,
  layout,
}) => {
  if (!description) {
    return null
  }

  const isRow = layout === 'horizontal' || layout === 'toolbar'
  return (
    <div className={cn(s.root, { [s.fluid]: isRow })}>
      <Typography styleType='hint'>{description}</Typography>
    </div>
  )
}

export default React.memo(FieldBaseDescription) as typeof FieldBaseDescription
